import * as React from "react";
import { Pagination, List, Datagrid, TextField, NumberInput, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';
import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "./../styles/common.js";
import Stack from '@mui/material/Stack';
import config from "../config";
import {downloadFile} from "../utils/utils"

const filters = [
    <TextInput label="ID" source="id" alwaysOn />,
    <TextInput label="Nom" source="product" />,
];


const exportProducts = () => {
    downloadFile(config.API_HOST+"/exports/products", "products.csv");
}

export const ProductList = props => (
    <List exporter={exportProducts} {...props} filters={filters} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des produits" />
        <Datagrid rowClick="edit">
            <TextField source="id" label="ID" />
            <ReferenceField link={false} label="Famille" source="productFamilyId" reference="productFamilies">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="" label="" />
            <TextField source="product" label="Nom" />
            <TextField source="price" label="Prix TTC" />
        </Datagrid>
    </List>
);

export const ProductEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Édition du produit" />
        <SimpleForm>
            <Stack direction="column" spacing={2} style={commonStyles.stackColumn}>
                <TextInput style={commonStyles.inputStyle} disabled source="id" label="Id" />
                <ReferenceInput label="Famille du produit" source="productFamilyId" reference="productFamilies" validate={required()}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <TextInput style={commonStyles.inputStyle} source="product" label="Nom" validate={required()} />
                <TextInput style={commonStyles.inputStyle} source="details" label="Détails" />
                <span style={commonStyles.inputStyle}>Pour changer un prix, veuillez supprimer le produit et en créer un nouveau.</span>
                <NumberInput style={commonStyles.inputStyle} source="price" disabled label="Prix TTC" validate={required()} />
                <SelectInput source="transportByCarMode" label="Mode de minimum pour la livraison en voiture" validate={required()} choices={[
                    { id: 'price', name: 'Minimum de prix sur la commande (TTC)' },
                    { id: 'quantity', name: 'Minimum de quantité sur le produit' },
                    { id: 'nothing', name: 'Aucune limite' },
                ]} />
                <NumberInput style={commonStyles.inputStyle} source="transportByCarValue" label="Valeur pour le minimum pour la livraison en voiture" validate={required()} />
                <NumberInput style={commonStyles.inputStyle} source="minDelay" label="Délai minimum (en jours)" validate={required()} />

            </Stack>
        </SimpleForm>
    </Edit>
);

export const ProductCreate = props => (
    <Create {...props}>
        <PageCreateTitle text="Création d'une promotion" />
        <SimpleForm>
            <Stack direction="column" spacing={2} style={commonStyles.stackColumn}>
                <ReferenceInput source="productFamilyId" reference="productFamilies" validate={required()}>
                    <SelectInput label="Famille du produit" optionText="name" />
                </ReferenceInput>
                <TextInput style={commonStyles.inputStyle} source="product" label="Nom" validate={required()} />
                <TextInput style={commonStyles.inputStyle} source="details" label="Détails" validate={required()} />
                <NumberInput style={commonStyles.inputStyle} source="price" label="Prix TTC" validate={required()} />
                <SelectInput source="transportByCarMode" label="Mode de minimum pour la livraison en voiture" validate={required()} choices={[
                    { id: 'price', name: 'Minimum de prix sur la commande (TTC)' },
                    { id: 'quantity', name: 'Minimum de quantité sur le produit' },
                    { id: 'nothing', name: 'Aucune limite' },
                ]} />
                <NumberInput style={commonStyles.inputStyle} source="transportByCarValue" label="Valeur pour le minimum pour la livraison en voiture" validate={required()} />
                <NumberInput style={commonStyles.inputStyle} source="minDelay" label="Délai minimum (en jours)" validate={required()} />
            </Stack>
        </SimpleForm>
    </Create>
);